import ChannelsChart from "./ChannelsChart";

const ChannelsTab = ({ channels }) => <ChannelsChart channels={channels} />;

export default ChannelsTab;
